import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RouteType } from 'src/app/models/navigation/route-type.enum';
import { TabLink } from '../../models/navigation/tab-link.model';
import { UserTypology } from '../../models/userTypology.enum';
import { NavigationService } from '../../services/navigation.service';
import { ReferenceService } from '../../services/reference.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'fs-tab-bar',
  templateUrl: './tab-bar.component.html',
  styleUrls: ['./tab-bar.component.sass']
})
export class TabBarComponent implements OnInit {
  tabBarStructure: TabLink[];
  isUserSlLi: boolean;
  userInformations: any;

  constructor(
    private navigationService: NavigationService,
    private referenceService: ReferenceService,
    private userService: UserService,
    private router: Router
  ) { }

  ngOnInit() {
    const userInfos = this.navigationService.getUserInfos();
    this.tabBarStructure = this.navigationService.getTabBarData();
    this.userInformations = {
      name: userInfos.firstName + ' ' + userInfos.lastName,
      mail: userInfos.email,
      agence: userInfos.agency.name,
      id: userInfos.idRcu,
    };
  }

  changeRoute(event: any): Promise<boolean> {
    if (!event.detail) {
      return;
    }
    if (event.detail.id === 'logout') {
      this.userService.logout().subscribe({error: logoutError => console.error('Logout failed', logoutError)});
      return;
    }
    if (event.detail.id === 'agencyLI') {
      window.location.href =
      `${this.referenceService.staticReferences.DuoDomain}/switch-space/`;
      return;
    }
    if (event.detail.type === RouteType.Internal) {
      return this.router.navigate([event.detail.route]);
    }
    if (event.detail.targetBlank) {
      // Make sure we take the external url to route outside the app
      const externalUrl = this.navigationService.getActivableLinksData().find(item => item.code === event.detail.id)
        .app.url;
      window.open(externalUrl);
      return;
    }

    window.location.href = event.detail.route;
  }

}
